import { render, staticRenderFns } from "./register-panel.vue?vue&type=template&id=64442790"
import script from "./register-panel.vue?vue&type=script&lang=js"
export * from "./register-panel.vue?vue&type=script&lang=js"
import style0 from "./register-panel.vue?vue&type=style&index=0&id=64442790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports